<template>
    <div :class="itemClass" @click="checkPaywallAction()">
        <div v-bind="linkProps">
            <common-icon v-if="icon" :name="icon" size="large"></common-icon>

            <span :class="contentClass">
                {{ label }}
                <span v-if="isHighlightNeeded">
                    {{ highlight }}
                </span>
            </span>

            <common-badge v-if="badge" :content="badge"></common-badge>
        </div>
    </div>
</template>

<script>
    import { isRouteNameEqual, matchFullRoute } from '~/helpers'

    export default {
        props: {
            route: { type: Object, default: undefined },
            url: { type: String, default: undefined },
            label: { type: String, required: true },
            icon: { type: String, default: undefined },
            badge: { type: [Number, String], default: undefined },
            isNested: { type: Boolean, default: false },
            highlight: { type: String, default: '' },
            showPaywall: { type: Boolean, default: false },
        },

        data() {
            return {
                isOverflowing: false,
            }
        },

        computed: {
            itemClass() {
                return {
                    'app-main-menu__item': true,
                    'app-main-menu__item--is-current': this.route
                        ? this.route.matchFullRoute
                            ? matchFullRoute(this.route, this.$route, 2)
                            : isRouteNameEqual(this.route.name, this.$route.name, 2)
                        : false,
                    'app-main-menu__item--is-nested': this.isNested,
                }
            },

            linkProps() {
                if (this.showPaywall && this.$auth.isUserPracticeDemo()) {
                    return { is: 'a', href: this.url }
                }
                return this.route ? { is: 'router-link', to: this.route } : { is: 'a', href: this.url }
            },

            defaultClassName() {
                return 'menu-item-label'
            },

            isHighlightNeeded() {
                return this.highlight && this.isOverflowing
            },

            contentClass() {
                return this.defaultClassName + (this.isHighlightNeeded ? ' full-label-text' : '')
            },
        },

        methods: {
            checkPaywallAction() {
                if (this.showPaywall && this.$auth.isUserPracticeDemo()) {
                    this.emitEvent({ name: 'open-paywall-modal' })
                }
            },
        },

        mounted() {
            const currentPosition = this.$el.style.position
            this.$el.style.position = 'relative'
            const spanElement = this.$el.getElementsByClassName(this.defaultClassName)[0]
            this.isOverflowing =
                spanElement.clientWidth < spanElement.scrollWidth || spanElement.clientHeight < spanElement.scrollHeight
            this.$el.style.position = currentPosition
        },
    }
</script>
